export type PreviewQuality = 'compressed' | 'full';

interface ProjectVideoUrls {
  compressed_cut_video_url?: string | null;
  compressed_base_video_url?: string | null;
  cut_video_url?: string | null;
  base_video_url?: string | null;
}

/** Which source video the editor previews.
 *
 *  `compressed` (the historic default) is lighter — faster to load and to
 *  scrub. `full` is the original for visual fidelity. Preview only: exports
 *  always render from the full-quality source on the worker, regardless of
 *  this choice. `hasQualityChoice` gates the toggle — no point offering it
 *  when only one tier exists. */
export function resolvePreviewVideoUrl(
  { quality, project }: { quality: PreviewQuality; project: ProjectVideoUrls },
): { url: string; hasQualityChoice: boolean } {
  const compressed =
    project.compressed_cut_video_url || project.compressed_base_video_url || '';
  const full = project.cut_video_url || project.base_video_url || '';
  const hasQualityChoice = Boolean(compressed && full && compressed !== full);
  const url = quality === 'full' ? (full || compressed) : (compressed || full);
  return { url, hasQualityChoice };
}
